import UploadNewsForm from "../../UploadNewsForm";
import { createSaint } from "../../../api";
import { Container } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function CreateNewSaint() {
  const navigate = useNavigate();
  const customSubmitFunction = async (title, description, image) => {
    try {
      const result = await createSaint(title, description, image);
      if (result) {
        navigate("/saint/all");
      }
    } catch (error) {}
  };
  return (
    <>
      <Container>
        <UploadNewsForm
          customsubmit={customSubmitFunction}
          breadCrumbLink={"Saint"}
          breadCrumbText={"Create New"}
          goBackLink={"/saint/all"}
        />
      </Container>
    </>
  );
}
